import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const SearchIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="m15 14.29-3.51-3.51a5.906 5.906 0 0 0 1.41-3.84c0-3.28-2.67-5.95-5.95-5.95C3.67.99 1 3.67 1 6.95s2.67 5.95 5.95 5.95c1.46 0 2.8-.53 3.83-1.41L14.29 15l.71-.71ZM6.95 11.9C4.22 11.9 2 9.68 2 6.95S4.22 2 6.95 2s4.95 2.22 4.95 4.95-2.22 4.95-4.95 4.95Z" />
  </IconWrapper>
)

export default SearchIconSmall
